import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import { Link } from 'react-router-dom';
import { faFileInvoice, faCircle } from '@fortawesome/free-solid-svg-icons';

const Previsao = ({ previsao: { id, processo, data, modalidade, destino, operacao, title, referencia, cor }, isLast }) => {
  let sigla = operacao === 'Agenciamento' ? 'A' :
    operacao === 'Exportação' ? 'E' : 'I';
  let corCircle = cor;
  return (
    <Row className="g-3 pb-s1">
      <Col>
        <Row className={classNames('g-3', { 'mb-3 border-bottom pb-s1': !isLast })}>
          <Col xs={2} md={1} sm={1} className="d-flex justify-content-center">
            <FontAwesomeIcon
              icon={classNames({
                plane: modalidade === 'AÉREO' || modalidade === 'AIRFREIGHT' || modalidade === 'Aéreo',
                truck: modalidade === 'RODOVIÁRIO' || modalidade === 'Rodoviário' || modalidade === 'RODOVIARIO',
                ship: modalidade === 'Marítimo' || modalidade === 'Maritimo' || modalidade === 'MARITIMA' || modalidade === 'MARÍTIMO (LCL)' || modalidade === 'MARÍTIMO (FCL)'
              })}
              size="lg"
            />
          </Col>
          <Col xs={6} sm={2}>
            <h6 className="text-800 mb-1 text-center" style={{ fontSize: '12px' }}>{processo}</h6>
          </Col>
          <Col xs={6} sm={2}>
            <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>{referencia}</h6>
          </Col>
          <Col xs={2} sm={1} className="d-flex justify-content-center">
            <FontAwesomeIcon icon={faCircle} style={{ color: corCircle }} size="lg" />
          </Col>
          <Col xs={6} sm={2}>
            <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>{data}</h6>
          </Col>
          <Col xs={6} sm={3}>
            <h6 className="text-800 mb-1 text-center" style={{ fontSize: '12px' }}>{destino}</h6>
          </Col>
          <Col xs={2} sm={1} className="d-flex justify-content-center align-items-center">
            <Link to={{ pathname: '/app/process/process-details/' + sigla + '&' + id }}>
              <FontAwesomeIcon icon={faFileInvoice} title='Detalhes' style={{ cursor: 'pointer' }} size="lg" />
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const DeadLine = ({ data, title }) => {
  return (
    <Card className="h-100 recent-activity-card">
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact style={{ height: '26rem' }}>
        <Card.Body className="ps-2 recent-activity-body-height">
          <Row className="g-3 mb-2 border-bottom pb-s1">
            {[
              { color: 'black', label: 'Prazo expirado' },
              { color: 'red', label: 'Prazo expira hoje' },
              { color: 'orange', label: 'Prazo expira em 1 a 2 dias' },
              { color: 'green', label: 'Dentro do Prazo' }
            ].map(({ color, label }, index) => (
              <Col xs={6} sm={3} key={index} className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faCircle}
                  className="me-2"
                  style={{ color }}
                  size="sm"
                />
                <h6 className="text-800 mb-0" style={{ fontSize: '0.625em' }}>
                  {label}
                </h6>
              </Col>
            ))}
          </Row>
          <Row className="g-3 mb-3 border-bottom pb-s1">
            <Col xs={6} sm={1} key={"Modal"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Modal
              </h6>
            </Col>
            <Col xs={6} sm={2} key={"Processo"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Processo
              </h6>
            </Col>
            <Col xs={6} sm={2} key={"Referência"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Referência
              </h6>
            </Col>
            <Col xs={6} sm={1} key={"Status"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Status
              </h6>
            </Col>
            <Col xs={6} sm={2} key={"Prazo"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Prazo
              </h6>
            </Col>
            <Col xs={6} sm={3} key={"Destino"}>
              <h6 className="text-800 mb-1 text-center" style={{ fontSize: '0.625em' }}>
                Destino
              </h6>
            </Col>
         
          </Row>
          {data.map((previsao, index) => (
            <Previsao
              key={previsao.processo}
              previsao={previsao}
              isLast={index === data.length - 1}
              referencia={previsao.ident_cli_pro}
              cor={previsao.cor}
            />
          ))}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Previsao.propTypes = {
  previsao: PropTypes.shape({
    id: PropTypes.number,
    processo: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    modalidade: PropTypes.string.isRequired,
    destino: PropTypes.string.isRequired,
    operacao: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    referencia: PropTypes.string.isRequired,
    cor: PropTypes.string.isRequired,
  }),
  isLast: PropTypes.bool
};

DeadLine.propTypes = {
  data: PropTypes.arrayOf(Previsao.propTypes.previsao)
};

export default DeadLine;
